import './ReviewStep.scss';

import { bem } from 'mission-control-common-components';
import React, { useMemo } from 'react';

import UploadTagSheetContentWrapper from '../components/UploadTagSheetContentWrapper';
import UploadTagSheetHeader from '../components/UploadTagSheetHeader/UploadTagSheetHeader';
import UploadTagSheetHeaderTitle from '../components/UploadTagSheetHeaderTitle/UploadTagSheetHeaderTitle';
import { useUploadTagSheetContext } from '../UploadTagSheetStepperProvider/UploadTagSheetStepperProvider';
import { REVIEW_STEP_TITLE, TAG_SHEET_NO_SUBMITTABLE_ADS_TITLE } from './constants';
import { useSaveTagSheetAds } from './hooks/useSaveTagSheetAds';
import ReviewTable from './ReviewTable/ReviewTable';
import { getReviewLineItems } from './utils';

const [, element] = bem('review-step');

const ReviewStep = (): React.JSX.Element => {
  const { parseResult } = useUploadTagSheetContext();
  const { save, loading } = useSaveTagSheetAds(parseResult);

  const reviewLineItems = useMemo(() => (parseResult ? getReviewLineItems(parseResult) : []), [parseResult]);

  return (
    <div>
      <UploadTagSheetHeader
        title={<UploadTagSheetHeaderTitle title={REVIEW_STEP_TITLE} vendorName={parseResult?.vendor.name} />}
        confirmText="Save"
        onNext={save}
        loading={loading}
        confirmButtonDisabled={reviewLineItems.length === 0}
      />
      {reviewLineItems.length > 0 ? (
        <div className={element('table-container')}>
          <ReviewTable reviewLineItems={reviewLineItems} />
        </div>
      ) : (
        <UploadTagSheetContentWrapper>
          <p>{TAG_SHEET_NO_SUBMITTABLE_ADS_TITLE}</p>
        </UploadTagSheetContentWrapper>
      )}
    </div>
  );
};

export default ReviewStep;
